export type Counts = {
  _0?: number;
  _25?: number;
  _50?: number;
  _75?: number;
  _100?: number;
  _125?: number;
};

export interface CollectionPlan {
  enabled: boolean;
  frequency: string;
  weekdays: string[];
  ordinal: string;
  monthlyWeekday: string;
  weekOffset: number;
  anchorMonth: number;
  timezone: string;
  notes: string;
}

export interface EquipmentStats {
  totalDeclarations: number;
  sums: {
    _0: number;
    _25: number;
    _50: number;
    _75: number;
    _100: number;
    _125: number;
    equivalentFullUnits: number;
  };
  avgs: {
    _0: number;
    _25: number;
    _50: number;
    _75: number;
    _100: number;
    _125: number;
    equivalentFullUnits: number;
  };
  updatedAt?: Date;
}

export interface EquipmentsRecord {
  _id: string;
  name: string;
  size: string;
  unit: string;
  quantity: number;
  waste: string;
  active: boolean;
  density: number;
  collectionPlan?: CollectionPlan;
  stats?: EquipmentStats;
}

export interface SiteResponse {
  site: {
    _id: string;
    name: string;
    equipments: EquipmentsRecord[];
  };
}

export interface RemovalRecord {
  id: string;
  site: string;
  equipment: string;
  equipmentData: EquipmentsRecord;
  counts: Counts;
  equivalentFullUnits: number;
  note?: string;
  quantityAtTheMoment: number;
  tonnage: number;
  createdAt: string;
  passedFrom: string;
}

/** Fréquences */
export const FrequencyChoices = [
  { id: "DAILY", name: "Quotidien" },
  { id: "WEEKLY", name: "Hebdomadaire" },
  { id: "BIWEEKLY", name: "Toutes les 2 semaines" },
  { id: "MONTHLY", name: "Mensuel" },
  { id: "QUARTERLY", name: "Trimestriel" },
  { id: "ANNUALLY", name: "Annuel" },
];

/** Jours de semaine (Enum côté API : MONDAY..SUNDAY) */
export const WeekdayChoices = [
  { id: "MONDAY", name: "Lundi" },
  { id: "TUESDAY", name: "Mardi" },
  { id: "WEDNESDAY", name: "Mercredi" },
  { id: "THURSDAY", name: "Jeudi" },
  { id: "FRIDAY", name: "Vendredi" },
  { id: "SATURDAY", name: "Samedi" },
  { id: "SUNDAY", name: "Dimanche" },
];

/** Ordinal pour mensuel/trimestriel/annuel */
export const OrdinalChoices = [
  { id: "FIRST", name: "1er" },
  { id: "SECOND", name: "2e" },
  { id: "THIRD", name: "3e" },
  { id: "FOURTH", name: "4e" },
  { id: "LAST", name: "Dernier" },
  { id: "ALL", name: "Tous (du mois)" }, // interprétation côté backend
];

/** Mois ancre (utile pour quarterly/annually) */
export const MonthChoices = [
  { id: 1, name: "Janvier" },
  { id: 2, name: "Février" },
  { id: 3, name: "Mars" },
  { id: 4, name: "Avril" },
  { id: 5, name: "Mai" },
  { id: 6, name: "Juin" },
  { id: 7, name: "Juillet" },
  { id: 8, name: "Août" },
  { id: 9, name: "Septembre" },
  { id: 10, name: "Octobre" },
  { id: 11, name: "Novembre" },
  { id: 12, name: "Décembre" },
];
